import { isRegistrationComplete } from '@btcdirect/functions';
import { useApiCommunicator } from '@btcdirect/shared/src/composables/api/communicator';
import { Endpoints } from '@btcdirect/shared/src/composables/api/endpoints';
import { ApiCommunicationStates, ApiRequestData } from '@btcdirect/shared/src/composables/api/types';
import { OnboardingRequirements } from '@btcdirect/shared/src/composables/api/user/types';
import { useLogger } from '@btcdirect/shared/src/composables/util/logger';
import { usePartnerInfo } from '@btcdirect/shared/src/composables/util/partner-info';
import { computed, reactive } from 'vue';

const { warn } = useLogger();

interface State {
    requirements: OnboardingRequirements;
    communication: ApiCommunicationStates;
}

const state = reactive<State>({
    requirements: [] as OnboardingRequirements,
    communication: ApiCommunicationStates.NOT_STARTED
});

export const useUserStatus = () => {
    const { get } = useApiCommunicator(Endpoints.USER_STATUS);

    const status = async (): Promise<void> => {
        if (state.communication === ApiCommunicationStates.SUCCESSFUL && (!state.requirements || !state.requirements.length)) {
            return;
        }

        const { id: partnerId } = usePartnerInfo();
        const payload: ApiRequestData = !!partnerId.value ? { apiClientId: partnerId.value } : null;

        try {
            state.communication = ApiCommunicationStates.COMMUNICATING;

            state.requirements = await get(payload);

            state.communication = ApiCommunicationStates.SUCCESSFUL;
        } catch (exception) {
            warn("Could not retrieve the user's status");
            state.communication = ApiCommunicationStates.FAILED;
            return Promise.reject(exception);
        }
    };

    return {
        requirements: computed<OnboardingRequirements>(() => state.requirements),
        registrationCompleted: computed<boolean>(() => isRegistrationComplete(state.requirements)),
        resetCommunication: () => (state.communication = ApiCommunicationStates.NOT_STARTED),
        status
    };
};
